module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/150730-000002-WPYDRV-c243df5bf6ad4d95af32528c441016d9.jpg";